import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Reviews = () => {
    const [reviews, setReviews] = useState([]);
    const [reviewFiltered, setReposFiltered] = useState([]);
    const [repos, setRepos] = useState([]);
    const [keywords, setKeywords] = useState([]);

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_reviews', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setReviews(data);
                setReposFiltered(data);
                let repos_aux = [];
                for (let i = 0; i < data.length; i++) {
                    if (!repos_aux.includes(data[i].owner + '/' + data[i].name)) {
                        repos_aux.push(data[i].owner + '/' + data[i].name);
                    }
                }
                setRepos(repos_aux);
                let keywords_aux = [];
                for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < data[i].keywords.length; j++) {
                        if (!keywords_aux.includes(data[i].keywords[j])) {
                            keywords_aux.push(data[i].keywords[j]);
                        }
                    }
                }
                setKeywords(keywords_aux);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, []);

    function filter() {
        let aux_repos = reviews;
        let currentRepo = document.getElementById('selectRepo').value;
        if (currentRepo !== "") {
            aux_repos = aux_repos.filter(review => review.owner + '/' + review.name === currentRepo);
        }

        let keywords_aux = [];
        for (let i = 0; i < aux_repos.length; i++) {
            for (let j = 0; j < aux_repos[i].keywords.length; j++) {
                if (!keywords_aux.includes(aux_repos[i].keywords[j])) {
                    keywords_aux.push(aux_repos[i].keywords[j]);
                }
            }
        }

        let currentKeyword = document.getElementById('selectKeyword').value;

        if (currentKeyword !== "" && currentKeyword !== "None") {
            aux_repos = aux_repos.filter(review => review.keywords.includes(currentKeyword));

        }
        if (currentKeyword === "None") {
            aux_repos = aux_repos.filter(review => review.keywords.length === 0);
        }

        setReposFiltered(aux_repos);
        setKeywords(keywords_aux);

        document.getElementById('selectKeyword').value = currentKeyword;
    }


    return (
        <>
            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Reviews</h1>
                </div>
            </div>

            <div className="m-10 border-b border-gray-900/10">
                <div className="justify-center">
                    <h2 className="text-base font-medium leading-7 text-gray-900">Filters</h2>
                </div>

                <div className="grid grid-cols-4">
                    <div class="flex flex-wrap -mx-3 mb-2 col-span-2">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="selectRepo">
                            Repos:
                        </label>
                        <div class="relative">
                            <select id="selectRepo" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" onChange={(e) => filter()}>
                                <option value="">All</option>
                                {repos.map(repo => (
                                    <option key={repo} value={repo}>{repo}</option>
                                ))}
                            </select>
                            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-wrap -mx-3 mb-2 col-span-2">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="selectKeyword">
                            Keywords:
                        </label>
                        <div class="relative">
                            <select id="selectKeyword" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" onChange={(e) => filter()}>
                                <option value="">All</option>
                                <option value="None">None</option>
                                {keywords.map(keyword => (
                                    <option key={keyword} value={keyword}>{keyword}</option>
                                ))}
                            </select>
                        </div>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-5 lg:grid-cols-8">
                {reviewFiltered.map(review => (
                    <div key={review.comment_id + review.owner + review.name} 
                    className={`col-span-1 shadow-md hover:shadow-lg m-5 ${review.correct === false ? 'bg-gray-400' : review.security === true ? 'bg-green-400' : review.security === false ? 'bg-red-400' : ''}`}>
                        <Link to={`/review/${review.comment_id}/${review.original_commit}/${review.fix_commit}`}>
                            <p><b>Comment_id:</b> {review.comment_id}</p>
                            <p><b>Repo:</b> {review.owner + '/' + review.name}</p>
                        </Link>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Reviews;